import React from 'react'
import {formatCurrency} from "../../utils/commonutils";
import {Button, Icon, Label, Modal, Table} from "semantic-ui-react";
import {sendReport} from "../../redux/modules/billing";
import SummaryCodeAmountChips from "./SummaryCodeAmountChips";

const numberSort = (direction, attr) => (a, b) => (+a[attr] - +b[attr]) * direction

const headers = [
    {title: "Practice", value: 'Practice'},
    {title: "Patient Number", value: 'PatNum', sort: numberSort},
    {title: "Date of Service", value: 'ProcDate'},
    {title: "Entry Date", value: 'DateEntry'},
    {title: "Procedure Code", value: 'ProcCode'},
    {title: "ADJ Code", value: 'ADJ_Type'},
    {title: "Amount", value: 'AdjAmt', sort: numberSort}
];

function CalendarAdjustments(props) {
    const [open, setOpen] = React.useState(false);
    const [sort, setSort] = React.useState(headers[0].value);
    const [direction, setDirection] = React.useState(1);

    const abbr = props.providerPayByPractice?.ABBR;
    const groupedAdjustments = props.payData?.adjustmentGroupByDentistByPractice?.[abbr];
    const adjWoProcDateStart = props.providerPayByPractice?.doctorPayVariables?.GreaterofAdjWOProcdateStart;
    const data = Object.values(groupedAdjustments?.data ?? {}).map(p => Object.values(p.data)).flat(2);

    const send = () => {
        const {dispatch, user} = props;
        dispatch(sendReport({
            detailsModalType: 'adjustment',
            detailsModal: 'report',
            eventClick: 'month',
            mtdBillable: '',
            productionPrice: false,
            eventDate: false,
            startDate: props.startDate,
            abbr: user.UdaDrList.abbr,
            prodAdjWo: user.UdaDrList.prodAdjWo
        }))
            .catch((err) => {
                console.log('Err =====>>>>> ', err);
                alert('Email sending failed. Please try again.');
            });
        setOpen(false);
        alert('Sending email...');
    }

    const onSort = (sort) => {
        setSort(sort);
        setDirection(direction * -1)
    }

    const sortFunc = headers.find(h => h.value === sort)?.sort?.(direction, sort);
    const defaultSortFunc = (a, b) => a[sort]?.toString().localeCompare(b[sort]) * direction;

    return <Modal
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        open={open}
        size='large'
        closeIcon={true}
        trigger={<span>
            Adjustments: <b>{formatCurrency(groupedAdjustments?.price ?? 0)}</b>
        </span>}
    >
        <Modal.Header>
            {props.providerPayByPractice?.doctorName}
            <Label
                className="ml-3"
                content={formatCurrency(groupedAdjustments?.price ?? 0)}
                detail="Adjustments"
                basic={true} color="blue"
            />
            {adjWoProcDateStart && (
                <Label
                    className="ml-3"
                    content={`Proc Date ≥ ${adjWoProcDateStart}`}
                    detail="Filter Active"
                    color="orange"
                    size="small"
                />
            )}
            <SummaryCodeAmountChips title="Adjustment codes summary:" name="ADJ_Type" value="AdjAmt" data={data ?? []}/>
        </Modal.Header>
        <Modal.Content>
            <div className="table-responsive FreezeTable">
                <Table striped={true}>
                    <Table.Header>
                        <Table.Row>
                            {headers.map((h, i) => <Table.HeaderCell
                                className="cursorPointer"
                                key={h.value + i}
                                onClick={() => onSort(h.value)}
                                active={sort === h.value}
                            >
                                <Icon
                                    name={`sort content ${direction === 1 ? 'ascending' : 'descending'}`}
                                    color={sort === h.value ? 'orange' : 'grey'}
                                    style={{cursor: 'pointer'}}
                                />
                                {h.title}
                            </Table.HeaderCell>)}
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {
                            data?.sort(sortFunc ?? defaultSortFunc).map((item, index) => (<Table.Row key={index}>
                                <Table.Cell content={props.getPracticeName(item.Practice)}/>
                                <Table.Cell content={item.PatNum}/>
                                <Table.Cell content={item.ProcDate}/>
                                <Table.Cell content={item.DateEntry}/>
                                <Table.Cell content={item.ProcCode}/>
                                <Table.Cell content={item.ADJ_Type}/>
                                <Table.Cell content={<b>{formatCurrency(item.AdjAmt)}</b>}/>
                            </Table.Row>))
                        }
                    </Table.Body>
                </Table>
            </div>
        </Modal.Content>
        <Modal.Actions>
            <Button primary onClick={() => send()}>Send Report</Button>
            <Button onClick={() => setOpen(false)}>Close</Button>
        </Modal.Actions>
    </Modal>;
}


export default CalendarAdjustments